import classes from './index.module.scss';
import { Dialog, DialogContent } from '@mui/material';
import { assessmentMessages } from '../../constants/messages';
import TimerImage from '../../assets/images/TimerImg.png';
import { useAppSelector } from '../../hooks/useAppSelector';

interface TimerDialogProps {
  time: number;
  open: boolean;
}

const TimerDialog = ({ time, open }: TimerDialogProps) => {
  const assessmentState = useAppSelector((state) => state.assessment);
  return (
    <Dialog open={open} fullScreen={true} fullWidth>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.innerContainer}>
          <img src={TimerImage} className={classes.timerImg} />
          {assessmentState.is_bot
            ? assessmentMessages.interviewTimerMessage
            : assessmentMessages.timerMessage}
          <div className={classes.iconContainer}>{time}</div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TimerDialog;
